import { initFederation } from '@angular-architects/module-federation';
import { environment } from './environments/environment';

initFederation(environment.manifest)
  .catch(err => console.info(err))
  .then(_ => import('./bootstrap'))
  .catch(err => console.info(err));
